<pw-view-title>{{(pos$ | async)?.NAME}}</pw-view-title>

<mat-accordion *ngIf="pbo$ | async; let pbo">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>{{'orders.eta.orderInformation' | translate}}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="ps-grid-4-col">
      <div>{{'orders.eta.description' | translate}}: {{pbo.DESCRIPTION}}</div>
      <div>{{'orders.eta.supplier' | translate}}: {{pbo.LIEFERANT}}</div>
      <div>{{'orders.eta.project' | translate}}: {{pbo.PROJEKTNAME}}</div>
      <div>{{'orders.eta.orderInformation' | translate}}: {{pbo.TERMIN | date}}</div>
      <div>{{'orders.eta.status' | translate}}:
        <img *ngIf="pboStatusIcons" src="{{pboStatusIcons[pbo.LIEFERSTATUS_ICON]}}"/>{{pbo.LIEFERSTATUS}}
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<mat-form-field style="padding-top: 16px">
  <mat-label>Filter</mat-label>
  <input type="text" matInput placeholder="Filter" [formControl]="searchFormControl">
</mat-form-field>

<div *ngIf="(etaDocuments$ | async) as etaDocs">
  <div [ngSwitch]="etaDocs.length">
    <div *ngSwitchCase="0">
      <mat-card>
        <mat-card-content>
          {{'orders.eta.noRetrievalDocuments' | translate}}
        </mat-card-content>
      </mat-card>
    </div>
    <div *ngSwitchDefault class="ps-grid-3-col">
      <mat-card *ngFor="let doc of etaDocs">
        <mat-card-content>
          {{doc.NAME}}
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-button color="primary" matTooltip="Herunterladen" (click)="downloadDocument(doc.OBJECT_ID)">
            <mat-icon>download</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>

</div>

